<template>
    <div class="">
      <el-form :inline="true" class="demo-form-inline clearfix">
        <el-form-item label="角色编码：" class="tinp">
            <el-input v-model="role_code" placeholder="请输入角色名或编码" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
        </el-form-item>
        <el-form-item label="角色名称：" class="tinp">
            <el-input v-model="role_name" placeholder="请输入角色名或编码" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
        </el-form-item>
       <el-button type="primary" class="" size="small" icon="el-icon-search" @click="getlist">搜索</el-button> 
       <el-button type="primary" class="fr" size="small" icon="el-icon-plus" @click="addUser">新增</el-button>
      </el-form>
        <div class="tablebox kucun">
            <table style="width:100%">
                <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
                    <th style="width:264px">角色编码</th>
                    <th style="width:217px">角色名称</th>
                    <th style="width:217px">角色备注</th>
                    <th style="width:231px">创建时间</th>
                    <th>明细</th>
                    <th>删除</th>
                </tr>
                <tr v-for="(item,index) in tableList" :key="item.period">
                    <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px">
                          <span>{{item[head.key]}}</span>
                    </td>
                     <td style="border: 1px solid #56B8AA; height: 38px;width:8%">
                          <el-button type="warning" class="" size="mini" @click="modify(item.pk_role,item.role_code,item.role_name,item.role_memo,item.pk_menus)">明细</el-button>
                    </td>
                    <td style="border: 1px solid #56B8AA; height: 38px;width:8%">
                          <el-button type="danger" class="" size="mini" @click="dellist(item.pk_role)">删除</el-button>
                    </td>
                </tr>
                <tr v-if="tableList.length==0">
                        <td colspan="11" style="border:0;background-color: rgba(239,240,244,1);height:40px;color:#909399">暂无数据</td>
               </tr>
            </table>
        </div>
        <!-- fenye start -->
        <div class="block" style="text-align: center;margin:20px auto ">
              <span><el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="page"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count"></el-pagination></span>
        </div>
        <!-- fenye end -->
  
      <!-- Modal  start-->
      <div class="model roleModel" v-show="roleShow">
        <div class="content clearfix">
          <div class="title">
            <span class="fl">角色明细</span>
            <span class="fr" @click="closemodel"><i class="iconfont icon-guanbi"></i></span>
          </div>
          <div class="" style="margin: 20px;">
            <el-form :model="userForm" :rules="rules" ref="userForm" label-width="120px" class="demo-ruleForm my  clearfix" style="">
              <div class="">      
                  <el-form-item label="角色编号：" class="">
                      <el-input v-model="userForm.role_code" :disabled="true" auto-complete="off" clearable></el-input>
                  </el-form-item> 
                  <el-form-item label="角色名称：" class="" prop="role_name">
                      <el-input v-model="userForm.role_name" placeholder="请输入角色名" suffix-icon="el-icon-edit" clearable></el-input>
                  </el-form-item>
              </div> 
              <div class="" style="padding-top: 14px;border: 1px solid #d8e6e4;overflow-y: auto;overflow-x:hidden;height:300px"> 
                  <el-tree :data="roleList" :default-checked-keys="indexlist" show-checkbox default-expand-all node-key="pk_menu" ref="tree" highlight-current :props="defaultProps">
                  </el-tree> 
              </div>
              <el-button size="medium" type="primary" @click="submitForm('userForm')" style="margin-top: 20px" class="fr">保存修改</el-button>
            </el-form>
          </div><!-- getCheckedKeys -->
        </div>
      </div>
      <!-- Modal  end--> 
      <!-- model end -->
      <div class=""  v-loading.fullscreen.lock="fullscreenLoading"></div>
      <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel> 
    </div>
</template>
<script>
import { setCookie, getCookie, delCookie } from '../../../static/js/cookie.js'
// import MessageModel from '../../components/MessageModel'
export default {
    name: '',
    data() { 
        var validateName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('角色名不能为空'));
            } else {
                callback();
            }
        };       
        return {
            flag:false,
            msgShow:false,
            modelFlag:false,
            modelFlag2:false,
            butflag:true,
            butflag2:true,
            msg:'', 
            butmsg:'确认', 
            butmsg2:'确认', 
            methodName:'', 
            fullscreenLoading:false,
            utilpath:'',
            startkeys:'',
            endkeys:'',
            width:0,//动态宽度
            page: 1,
            pageSize: 10,
            count:0,
            role_code:'',
            role_name:'',
            role_name2:'',
            roleShow:false,
            menutypeFlag:false,
            tableHeads: [
                {
                  label: '角色编码',
                  key: 'role_code'
                },
                {
                  label: '角色名称',
                  key: 'role_name'
                }, 
                {
                  label: '角色备注',
                  key: 'role_memo'
                }, 
                {
                  label: '创建时间',
                  key: 'creationtime'
                }, 
            ],
            tableList: [],
            pk_role:'',
            role_name:'',
            userForm:{             
              role_code:'',
              role_name:'',
              role_memo:'',
              pk_menus:'',
              roleCode: '',
              roleName:'',
              page: 1,
              pageSize: 10,
            },
            roleList:[],
            indexlist:[],
            defaultProps: {
              children: 'children',
              label: 'menu_name'
            },
            rules: { 
                    role_name: [
                        { required: true, trigger: 'blur', validator: validateName }
                    ]
            }
        }
    },
    mounted() {
        this.utilpath = this.axios.defaults.baseURL;
        this.init();
        // this.getrole();
    },
    destroyed (){
            sessionStorage.removeItem("page");
            sessionStorage.removeItem("pageSize");
            sessionStorage.removeItem("rolesList");
            // sessionStorage.removeItem("role_code");
          //  console.log("清除session");
        },
    methods: {
          returnMsg(flag){ 
          this.modelFlag = false;
          if(flag){
              //  console.log("---进来了！！！----"+this.methodName);
                if(this.methodName =='deleteRole'){  
                      this.fullscreenLoading = true;
                      var param={
                        pk_role: this.pk_role,
                      }
                      this.$http.post(this.utilpath + '/deleteRole',param, { emulateJSON: true,_timeout:600 }).then((res) => { 
                        //  console.log(JSON.stringify(res.data));
                            if (res.data.status == '0') {
                              this.fullscreenLoading = false;
                              this.tableList = res.data.resultList;
                              this.count=res.data.countNum;
                              this.$message({
                                showClose: true,
                                message: '删除成功！',
                                type: 'success'
                              }); 
                              this.msgShow =false;
                            } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
                              this.fullscreenLoading = false;
                              this.modelFlag = true;
                              this.msgShow = true;
                              this.methodName = 'message';
                              this.msg = res.data.message;
                              this.butflag =false;
                              this.butmsg='知道了';
                            };
                      }, (err) => {
                        this.msgShow =false;
                            this.fullscreenLoading = false;
                            this.modelFlag = true;
                            this.methodName = 'message';
                            this.msg = '连接删除角色接口失败';
                            this.butflag =false;
                            this.butmsg='知道了';
                      });
                  }else if(this.methodName =='updateRole'){
                        this.fullscreenLoading = true;
                        var keys = this.$refs.tree.getCheckedKeys()
                        this.userForm.pk_menus=JSON.stringify(keys);
                        this.userForm.roleCode = this.role_code
                        this.userForm.roleName = this.role_name
                        this.$http.post(this.utilpath + '/updateRole',this.userForm, {emulateJSON: true,_timeout:600}).then((res) => { 
                          // console.log("进入修改修改：");
                          // console.log("打印修改返回值："+JSON.stringify(res));
                            this.fullscreenLoading = false;
                            if (res.data.status == '0') {
                              this.msgShow =false;
                              this.tableList = res.data.resultList;
                              this.count=res.data.countNum;
                              this.$message({
                                showClose: true,
                                message: '修改成功！',
                                type: 'success'
                              });
                              this.roleShow = false;
                            } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
                              this.fullscreenLoading = false;
                              this.modelFlag = true;
                              this.msgShow = true;
                              this.methodName = 'message';
                              this.msg = res.data.message;
                              this.butflag =false;
                              this.butmsg='知道了';
                            };
                          }, (err) => {
                            this.fullscreenLoading = false;
                            this.msgShow =false;
                            this.modelFlag = true;
                            this.methodName = 'message';
                            this.msg = '连接新增菜单接口失败';
                            this.butflag =false;
                            this.butmsg='知道了';
                        });
                  }
          }else{
            this.fullscreenLoading=false;
            this.$message({
              showClose:true,
              message:'已取消',
              type:'succcess'
            })
          }
        }, 
        returnMsg2(flag) { 
          this.modelFlag = false; 
           if (flag) {
           // console.log("---进来了！！！----" + this.methodName);
            if (this.methodName == 'message') {

            } 
          }
        },
        getCheckedKeys(){
            this.endkeys=this.$refs.tree.getCheckedKeys();
          //  console.log("--00000--");
          //  console.log(this.endkeys.toString());
            // this.menuTypemethod();

          // console.log("+++++++++++++++"+this.$refs.tree.getCheckedKeys()+"+++++++++++++++++++++");
        }, 
        selectMenuPk(role_code){
          var param ={ 
            role_code:role_code,
          }
          this.$http.post(this.utilpath + '/selectMenuPK',param,{ emulateJSON: true,_timeout:600 }).then((res) => {
                if (res.data.status == '0') {
                    this.indexlist = res.data.resultList; 
                    this.startkeys=this.indexlist.toString(); 
                } else if(res.data.status == '-1'){ 
                    this.startkeys=[];
                    this.$message({
                      showClose:true,
                      message:'暂无数据',
                      type:'info'
                    });
                    this.msgShow =false;
                } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
                    this.modelFlag = true;
                    this.msgShow = true;
                    this.methodName = 'message';
                    this.msg = res.data.message;
                    this.butflag =false;
                    this.butmsg='知道了';
                };
          }, (err) => {
                this.modelFlag = true;
                this.msgShow =false;
                this.methodName = 'message';
                this.msg = '连接获取菜单接口失败'+err;
                this.butflag =false;
                this.butmsg='知道了';
          }); 
      },
      selectMenu(pk_role){
        // var param ={ 
        //   pk_role:pk_role,
        // }
        this.$http.post(this.utilpath + '/selectTureMenuXu', { emulateJSON: true,_timeout:600 }).then((res) => {
          if (res.data.status == '0') {
              this.roleList = res.data.resultList; 
             // console.log("打印菜单："+JSON.stringify(this.roleList))
          } else if(res.data.status == '-1'){
              this.roleList = [];
              this.$message({
                  showClose:true,
                  message:'暂无数据',
                  type:'info'
              });
              this.msgShow =false;
          } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
              this.modelFlag = true;
              this.msgShow = true;
              this.methodName = 'message';
              this.msg = res.data.message;
              this.butflag =false;
              this.butmsg='知道了';
          };
        }, (err) => {
              this.modelFlag = true;
              this.msgShow =false;
              this.methodName = 'message';
              this.msg = '连接获取菜单接口失败'+err;
              this.butflag =false;
              this.butmsg='知道了';
        });

      },
      modify(pk_role,role_code,role_name,role_memo,pk_menus){
         this.role_name2=role_name
         // 初始化角色信息
         this.initJurisdiction();
         this.roleShow = true;
         this.userForm.pk_role = pk_role;
         this.userForm.role_code = role_code;
         this.userForm.role_name = role_name;
         this.userForm.role_memo = role_memo; 
         this.userForm.pk_menus = pk_menus; 
         this.indexlist = pk_menus;
        // console.log("打印下标："+pk_menus);
         // console.log("打印下标类型："+pk_menus instanceof String);

         // this.indexlist = pk_menus.split(',')
        // console.log("打印下标："+JSON.stringify(this.indexlist));
         // 获取角色权限列表 
         // this.getmenu(role_code);
         // this.selectMenuPk(role_code);
         this.selectMenu(pk_role);
         
        // console.log("打印活菜单："+JSON.stringify(this.userForm));
          
         
      },     
      closemodel(){
        this.roleShow = false;
      },
      dellist(pk_role){
        // this.$confirm('此操作将永久删除该用户，是否继续?', '提示', {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //       type: 'warning'
        //     }).then(() => { 
            this.pk_role = pk_role;
            this.methodName = 'deleteRole';
            this.modelFlag = true;
            this.msgShow =false;
            this.butflag = true;
            this.butmsg='确认';
            this.msg = '此操作将删除该角色，是否继续？'
            // }).catch(() => {
            //   this.$message({
            //     showClose: true,
            //     type: 'info',
            //     message: '已取消删除'
            //   });          
            // });         
      },
      addUser(){
        this.$router.push({ path: '/ui/system/roleManage/AddRole' });//跳转页面
      },
      init() {
            this.width = document.documentElement.clientWidth- 200;
            var list = JSON.parse(sessionStorage.getItem("rolesList")); 
            if(list == null ){
              //  console.log("List为空");
                this.getlist();
                 // this.getrole();
            }else{
                this.fullscreenLoading=false;
                this.page = parseFloat(sessionStorage.getItem("page"));
                this.pageSize = parseFloat(sessionStorage.getItem("pageSize"));
                this.tableList=list;
                this.count = this.tableList.length;
               // console.log("2");
            }
            // console.log("刷新数据"+JSON.stringify(list));
        },
        getrole(){
          this.tableList =[
            {
              role_code:'r00A',
              role_name:'系统管理员',
            },
            {
              role_code:'r001',
              role_name:'门店管理员',
            }
          ]
        },
        getlist(){//获取数据
          this.fullscreenLoading = true
            //搜索参数
            var reqparam = {
                  role_code: this.role_code,//角色编码
                  role_name: this.role_name,//角色名称
                  pageNum:this.page,
                  pageSize:this.pageSize,
            }; 
            this.$http.post(this.utilpath + '/selectRole',reqparam, { emulateJSON: true,_timeout:600 }).then((res) => { 
                  if(res.data.status =='0'){ 
                      this.fullscreenLoading = false;
                      this.tableList = res.data.resultList;
                      sessionStorage.removeItem("rolesList");
                      sessionStorage.setItem("rolesList",JSON.stringify(this.tableList));
                    //  console.log("查询数据"+JSON.stringify(this.tableList));
                      // console.log("session数据"+sessionStorage.getItem("kucunlist"));
                      this.count=res.data.countNum;
                     // console.log("打印数据长度："+this.count);
                  }else if(res.data.status =='-1'){
                     this.fullscreenLoading = false;
                      this.tableList =[];
                      this.count=0;
                      this.$message({
                          showClose:true,
                          message:'暂无数据',
                          type:'info'
                      });
                      this.msgShow =false;
                  } else if(res.data.status == '9'){
                    this.fullscreenLoading =false;
                    this.$router.push({path:'/ui/login',query:{msg:9}});
                  } else{
                      this.fullscreenLoading = false;
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                  }
                }, (err) => {
                    this.fullscreenLoading = false;
                    this.modelFlag = true;
                    this.msgShow =false;
                    this.methodName = 'message';
                    this.msg = '连接获取角色列表接口失败'+err;
                    this.butflag =false;
                    this.butmsg='知道了';
            });
            // sessionStorage.setItem("role_input",this.role_input);
            sessionStorage.setItem("page",this.page);
            sessionStorage.setItem("pageSize",this.pageSize);
        },
        handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
          this.pageSize = val;
          this.page=1; 
      this.getList();
         // console.log(this.pageSize);
        },
        handleCurrentChange(val) {
         // console.log(`当前页: ${val}`);
          this.page = val;
        //  console.log(this.page);
          this.getList();
        },
        onParamChange() {//搜索变更事件
             this.page = 1;
             this.fullscreenLoading = true
             this.getlist();
             // this.getrole();
        }, 
        initJurisdiction(){
          this.userForm = {             
              role_code:'',
              role_name:'',
              role_memo:'',
              pk_menus:'',
              roleCode: '',
              roleName:'',
              page: 1,
              pageSize: 10,
            };
        },
        menuTypemethod(){
            var reparm = {
              pk_menus:JSON.stringify(this.endkeys)
            }
           // console.log("打印查询菜单的参数："+JSON.stringify(reparm));
            this.$http.post(this.utilpath + '/checkMenuPKsType',reparm, { emulateJSON: true,_timeout:600 }).then((res) => { 
                  if(res.data.status =='0'){ 
                      this.menutypeFlag = true;
                      this.msgShow =false;
                  } else if(res.data.status == '9'){
                    this.fullscreenLoading =false;
                    this.$router.push({path:'/ui/login',query:{msg:9}});
                  } else{
                      this.fullscreenLoading = false;
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                  }
                }, (err) => {
                    this.fullscreenLoading = false;
                    this.msgShow =false;
                    this.modelFlag = true;
                    this.methodName = 'message';
                    this.msg = '连接获取查询菜单接口失败'+err;
                    this.butflag =false;
                    this.butmsg='知道了';
            });
        },
        submitForm(formName){
         this.getCheckedKeys();
         var flag = (this.startkeys==this.endkeys.toString()); 
         // console.log("+++++++++++++"+flag);
         // console.log("-1--"+this.startkeys);
         // console.log("-2--"+this.endkeys.toString());
         // console.log("+++++++++++++"+(this.startkeys == this.endkeys.toString()));
         if(flag&&this.userForm.role_name==this.role_name2){
              this.$message({
                      showClose: true,
                      message: '您并未修改任何内容！',
                      type: 'info'
              });
         }else{      
             this.$refs[formName].validate((valid) => {
                  if (valid) {  
                      this.methodName = 'updateRole';
                      this.modelFlag = true;
                      this.msgShow =false;
                      this.butflag = true;
                      this.butmsg='确认';
                      this.msg = '确定对该角色进行修改？' 
                  } else {
                    this.modify(this.userForm.role_code,this.userForm.role_name);
                    this.$message({
                      showClose: true,
                      message: '填写信息不符合！',
                      type: 'error'
                    });
                    return false;
                  }
                });
         }
      }
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/system/roleManage.vue